<template>
    <td class="td" v-bind:class="[column.classes]">
        <div ref="wrapper" class="cell-dropdown">
            <a class="table-field__link" @click="toggleMenu()" style="cursor: pointer;">
                <span>{{cellValue}}</span>
                <i class="arrow-drop-down"></i>
            </a>

            <div class="dropdown-menu-wrapper" v-if="showLinkDropDownMenu" v-bind:style="{top: this.blockPosition.top + 'px'}">
                <span class="close-icon-wrapper">
                  <i class="close" @click="closeDropDownMenu()"></i>
                </span>
                <div class="dropdown-menu">
                    <ul>
                        <li v-if="!$md.mobile()">
                            <span @click="showChart(row)">7 days range chart</span>
                        </li>
                        <li v-if="dropDownMenuUrls.length" v-for="item in dropDownMenuUrls">
                            <router-link :to="{ name: item.link, query: prepareUrlParams(row, item.paramsList, item.commonParamsList)}" target= '_blank'>{{item.label}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </td>
</template>

<script>
    export default {
        name: "cc-table-drop-down-view",
        props: {
            namespace: {
                type: String,
                required: true
            },
            cellValue: {
                type: [Number, String, Array, Object],
                required: true
            },
            dropDownMenuUrls: {
                type: Array,
                required: false
            },
            row: {
                type: Object,
                required: true
            },
            column: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                showLinkDropDownMenu: false,
                blockPosition: {
                    top: null
                } 
            }
        },
        mounted(){
        },
        methods: {
            toggleMenu: function(){
                this.showLinkDropDownMenu = !this.showLinkDropDownMenu;

                let elementPosition = this.$refs.wrapper.getBoundingClientRect();
                this.blockPosition.top = elementPosition.top;
            },
            closeDropDownMenu: function(){
                this.showLinkDropDownMenu = false;
            },
            prepareUrlParams: function(data, paramsList = null, commonParamsList = null){
                let params = {};
                let commonParams = {};
                let filtersList = this.$store.getters[this.namespace + '/getFilters'];

                let advancedFilters = filtersList.advancedFilters;
                let reportFilters = filtersList.filters;

                let commonData = {};
                if (reportFilters !== null && reportFilters !== undefined)
                {
                    commonData['datesComparison'] = reportFilters.dateComparisonStatus;
                    commonData['groupByDate'] = advancedFilters.groupByDate;
                    commonData['startDateB'] = reportFilters.dateRange.startDateB;
                    commonData['endDateB'] = reportFilters.dateRange.endDateB;
                }

                if (paramsList !== null)
                {
                    params = paramsList.reduce(function (acc, item) {
                        if (item !== null && data[item] !== undefined) {
                            acc[item] = data[item];
                        }

                        return acc;
                    }, {});
                }

                if (commonParamsList !== null && !(Object.keys(commonData).length === 0 && commonData.constructor === Object))
                {
                    commonParams = commonParamsList.reduce(function (acc, item) {
                        if (item !== null && commonData[item] !== undefined && commonData[item] !== null) {
                            acc[item] = commonData[item];
                        }

                        return acc;

                    }, {});

                    params = Object.assign(commonParams, params);
                }

                if (reportFilters.dateRange !== null && reportFilters.dateRange.startDate !== null && reportFilters.dateRange.endDate !== null)
                {
                    params['startDate'] = reportFilters.dateRange.startDate;
                    params['endDate'] = reportFilters.dateRange.startDate;
                }

                let preparedParams = {};
                for (let item in params)
                {
                    preparedParams[item] = JSON.stringify(params[item]);
                }

                return preparedParams;
            },
        }
    }
</script>

<style lang="scss" scoped>
    td.adgroup-column {
        & > .cell-dropdown {
            width: max-content;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/table/cellViewTypesHandlers/CCTableDropDownView.vue